import { IAssetLocationCreate, KeyStorageRule } from "../../../logic/api";

export function validateKeyLocation(
  params: Pick<IAssetLocationCreate, "keyStorageRule" | "keyStorageDate" | "keyStorageTimeslotId">,
  t: (key: string) => string
): string | null {
  if (params.keyStorageRule != null && params.keyStorageRule !== KeyStorageRule.Any) {
    if (params.keyStorageRule === KeyStorageRule.Date) {
      if (!params.keyStorageDate) {
        return t("locations.errors.keyStorageDateRequired");
      }
    } else if (params.keyStorageRule === KeyStorageRule.DateTimeSlot) {
      if (!params.keyStorageDate) {
        return t("locations.errors.keyStorageDateRequired");
      }
      if (!params.keyStorageTimeslotId) {
        return t("locations.errors.keyStorageTimeslotRequired");
      }
    }
  }
  return null;
}
